let BASE_URL;
switch (process.env.NODE_ENV) {
  case 'development':
    BASE_URL = 'http://localhost:3002/api';
    break;
  case 'production':
    BASE_URL = 'https://champion.plus/api';
    break;
  default:
    throw new Error(`unknown NODE_ENV: ${process.env.NODE_ENV}`);
}

export default {
  authUrl: `${BASE_URL}/auth.js`,
  clubUrl: `${BASE_URL}/club.js`,
  managerUrl: `${BASE_URL}/manager.js`,
  ownerUrl: `${BASE_URL}/owner.js`,
  dealerUrl: `${BASE_URL}/dealer.js`
};

